export default {
  register: {
    title: "Criar Conta FREE",
    subtitle:
      "Crie sua conta gratuita agora e comece a utilizar o ProcessFlex.",
    btn_create_your_account: "Criar Conta FREE",
    registered: {
      title: "Conta Registrada",
      msn:
        "Foi enviado ao seu email uma mensagem de confirmação. <br> Se não encontrar, verifique a caixa de spam.",
      check_email: "Verifique seu e-mail.",
      accept_terms: "Aceito os termos de uso.",
      accept_privacy_policy: "Aceito as políticas de privacidade.",
    },
  },
  home: {
    title: "Gestão de Processos e Perfis",
    subtitle: `
					Defina status, responsáveis, checklist, prazos e muito mais, tudo em um único sistema, fácil e flexível.
			`,
    features: {
      title: "Recursos",
      subtitle: "Conheça alguns dos recursos que o ProcessFlex oferece:",
      process: {
        desc: `
						<p class="text-justify">
							Use os processos pré-existentes ou crie novos tipos livremente. 
							Tenhas o controle dos teus processos com um configurador e 
							faça os ajustes para adequar cada tipo de processo à sua realidade.
						</p>
						<p class="text-justify"> 
							Defina status, quem participa deles, receba arquivos,
							envie mensagens, monte sua equipe e mais.
						</p>					
					`,
      },
      profile_and_cv: {
        desc: `
					<p class="text-justify">
						Canditatos, clientes, fornecedores, funcionários ou o que mais precisar,
						crie tipos de perfis novos e ajuste suas configurações livremente.
					</p>
					<p class="text-justify">
						Tenha links específicos para o registro diretamente pelo dono do perfil, seja 
						um candidato, cliente, fornecedor ou qualquer outro tipo de perfil.
					</p>					
					`,
      },
      custom_features: {
        desc: `
					<p class="text-justify">
						Possui necessidades únicas e não encontra soluções adequadas?
						Apenas você sabe o que a sua empresa realmente precisa.
					</p>
					<p class="text-justify">
						Entre em contato e vamos conversar para encontrarmos as melhores
						soluções para o seu caso.
					</p>
					`,
      },
    },
  },
  tasks: {
    desc: `
			<p>
			Facilite a gestão de suas tarefas e de sua equipe. Registre as tarefas e as gerencie de forma fácil e simples.
			</p>
			<p>
					Mantenha todas as tarefas em ordem. Controle seus status, defina responsabilidades, descreva atividades que devem ser concluídas, anexe arquivos e muito mais.
			</p>
			<p>
					Faça buscas de tarefas de maneira simples e inteligente para mantê-las organizadas e atualizadas. Quando concluídas, simplesmente "arquive-as" para referência futura ou para gerar relatórios sobre atividades passadas.
			</p>
				`,
    list: `
			<p><strong>Criação de Novas Tarefas:</strong> Registre novas tarefas de forma fácil e rápida;</p>
			<p><strong>Filtragem Inteligente:</strong> Busque suas tarefas por título, período, status, etc;</p>
			<p><strong>Criação Personalizada de Status:</strong> Crie os status que quiser, na ordem que desejar;</p>
			<p><strong>Visualização em Modo Kanban Board:</strong> 
					Tenha colunas com os status que você definiu e cartões com cada tarefa. Arraste para atualizar status, edite as tarefas como desejar;</p>
			<p><strong>Todo-list:</strong> Relacione tudo o que precisa ser feito para cada tarefa em uma lista e controle o que já foi feito;</p>
			<p><strong>Atribuição de Responsável pelas Tarefas:</strong> Defina quem é responsável pela tarefa;</p>
			<p><strong>Anexar Arquivos e Imagens:</strong> Anexe documentos e imagens para ter tudo o que está relacionado à tarefa em um só lugar;</p>
			<p><strong>Tarefas Derivadas:</strong> De uma tarefa principal, crie outras tarefas derivadas;</p>			
			`,
  },
  quotation_and_purchase: {
    desc: `
			<p>
				Transforme a gestão de compras da sua empresa com o nosso sistema de Cotação e Compras. 
				Simplifique o processo de solicitar cotações, analisar propostas e fechar negócios de maneira eficiente.
			</p>
			<p>
				Avalie e compare os melhores fornecedores, garantindo a escolha ideal para a sua empresa. 
				Além disso, mantenha controle total sobre as decisões, bloqueando as aprovações de compras até 
				serem autorizadas por um usuário designado. Aumente a eficiência operacional e tome decisões estratégicas
				para o crescimento do seu negócio.
			</p>
			`,
    list: `
			<p><strong>Registro de cotações e compras:</strong> Registre de forma fácil e rápida;</p>
			<p><strong>Filtragem Inteligente:</strong> Encontre os seus processos de forma simples;</p>
			<p><strong>Compare fornecedores:</strong> Defina os critérios de avaliação e escolha sempre a melhor opção conforme as avaliações feitas;</p>
			<p><strong>Cadastro de fornecedores:</strong> Mantenha o seu banco de dados de fornecedores sempre atualizado e disponível;</p>
			<p><strong>Anexe documentos:</strong> Anexe documentos digitalizados;</p>
			<p><strong>Atribuição de Responsável:</strong> Defina quem é responsável pelos processos;</p>		
			`,
    ai: {
      title: "IA",
      desc:
        "Use o poder da <strong>inteligência artificial</strong> para comparar fornecedores e fazer a melhor escolha.",
    },
  },

  resumes: {
    company: {
      desc: `
			<p>
				Crie e gerencie seu banco de currículos.
				Currículos adicionados por sua conta serão exclusivos aos seus usuários
				e compartilhável com links protegidos.
			</p>
			<p>
				<IconAI /> Use a <strong>inteligência artificial</strong> para gerar os textos de apresentação dos CVs.
			</p>`,
    },
    candidate: {
      desc: `
			<p>
				Tenha agora mesmo seu currículo de
				forma fácil, rápida e sem custo.
				Compartilhes através de links,
				PDF ou por impressão.
			</p>
			<p>
				<IconAI /> Use a <strong>inteligência artificial</strong> para gerar o texto de apresentação do seu CV.
			</p>`,
    },
  },
  recruitment: {
    title: "Recrutamento e Currículos ",
    subtitle: `
			<p>
			Tenha total controle dos processos de recrutamento e gestão
				da base de currículos da sua empresa.
			</p>
			<p>
				<ul class="text-left">
					<li>
						Gestão do recrutamento;
					</li>
					<li>
						Banco de Currículos;
					</li>
					<li>
						Área "Trabalhe Conosco";
					</li>
					<li>
						Outros processos e perfis configuráveis;
					</li>
					<li>
						Controle Financeiro;
					</li>
				</ul>
			</p>
			`,
    features: {
      title: "Recursos",
      subtitle: "Conheça alguns dos recursos que o ProcessFlex oferece:",
      process: {
        desc: `
						<p class="text-justify">
							Use os processos pré-existentes ou crie novos tipos livremente. 
							Tenhas o controle dos teus processos com um configurador e 
							faças os ajustes para adequar cada tipo de processo à sua realidade.
						</p>
						<p class="text-justify"> 
							Defina status, quem participa deles, receba arquivos,
							envie mensagens, monte sua equipa e mais.
						</p>					
					`,
      },
      profile_and_cv: {
        desc: `
					<p class="text-justify">
						Canditatos, clientes, fornecedores, funcionários ou quem mais precisas,
						crie tipos de perfis novos e ajuste suas configurações como precisas.
					</p>
					<p class="text-justify">
						Tenha links específicos para o registo diretamente pelo dono do perfil, seja 
						um candidato, cliente, fornecedor ou qualquer outro tipo de perfil.
					</p>					
					`,
      },
      custom_features: {
        desc: `
					<p class="text-justify">
						Possui necessidades únicas e não encontras soluções adequadas?
						Apenas tu sabes o que a sua empresa realmente precisa.
					</p>
					<p class="text-justify">
						Entre em contato e vamos conversar para encontrarmos as melhores
						soluções para o seu caso.
					</p>
					`,
      },
    },
  },
  plans: {
    subtitle: "Escolha um dos planos ou solicite uma solução sob medida.",
  },
  features: {
    title: "Recursos",
    subtitle: `
			<p>Recursos flexíveis e personalizáveis, como realmente precisa.</p>
			<p>
			ProcessesFlex é um sistema de gestão de processos e perfis. 
			Pode ser uma compra, um projeto, um processo seletivo, desenvolvimento de um produto
			ou qualquer outro processo que você precisa ter controle.<br>
			</p>
			<p>
			Defina quais os tipos de perfis que fazem parte do processo, os status, se há movimentação financeira, produtos, 
			comparação de perfis (para processos selectivos ou de cotação, por exemplo) e mais. <br>
			</p>
			<p>
			Tenha processos pré-configurados e personalize tudo a sua maneira.<br> 
			</p>
			<p>
			Se tiver alguma dúvida, entre em contato e tenha todo o suporte necessário.
			</p>
			`,
    processes: {
      title: "Processos",
      subtitle: "Crie e personalize processos",
      pre_registered: {
        title: "Pré-registrados:",
        list: `
					<ul class="col-md-5">
						<li>Tarefas;</li>
						<li>Recrutamento;</li>
						<li>Compras;</li>
						<li>Vendas;</li>
						<li>Projetos;</li>
					</ul>
					<ul class="col-md-5">
						<li>Cotação;</li>
						<li>Meeting;</li>
						<li>Contratação;</li>
						<li> E muito mais... </li>
					</ul>
				`,
      },
      features: {
        title: "Recursos",
        list: `
					<ul class="col-md-5">
						<li>Status personalizados;</li>
						<li>Tarefas vinculadas;</li>
						<li>Seleção de perfis;</li>
						<li>Avaliação de perfis;</li>
						<li>Comparação de perfis;</li>
						<li>Anexar aquivos;</li>
						<li>Enviar mensagem;</li>
					</ul>
					<ul class="col-md-5">
						<li>Productos e serviços;</li>
						<li>Controle de custos e receitas;</li>
						<li>Anexar arquivos;</li>
						<li>Prazos;</li>
						<li>Time line;</li>
						<li>Canban board;</li>
						<li>Atribua membros da equipe;</li>
					</ul>
					`,
      },
      new_types: {
        title: "Novos tipos de processos:",
        content:
          "Criação ilimitada de novos tipos de processos personalizados.",
      },
    },
    profiles: {
      title: "Base de Perfis",
      subtitle: "Base de perfis personalizável.",
      pre_registered: {
        title: "Pré-registrados:",
        list: `
					<ul>
						<li>Clientes</li>
						<li>Fornecedores</li>
						<li>Candidatos</li>
						<li>Consultores</li>
						<li>Funcionários</li>
					</ul>
					<ul>
						<li>Empregados</li>
						<li>Vendedores</li>
						<li>Transportadores</li>
						<li> E muito mais... </li>
					</ul>`,
      },
      features: {
        title: "Recursos",
        list: `
					<ul class="col-md-6">
						<li>Criação de CV;</li>
						<li>Buscas por skills, línguas, etc;</li>
						<li>Link exclusivo para registro;</li>
						<li>Processos vinculados;</li>
						<li>Avaliação de perfis;</li>
						<li>Comparação de perfis;</li>
						<li>Enviar mensagem;</li>
					</ul>
					<ul>
						<li>Anexar aquivos;</li>
						<li>Skills;</li>
						<li>Projetos;</li>
						<li>Línguas;</li>
						<li>Atividades;</li>
						<li>Educação;</li>
					</ul>
				`,
      },
      new_types: {
        title: "Novos tipos de perfis:",
        content: "Criação ilimitada de novos tipos de perfis personalizados.",
      },
    },
    tasks: {
      title: "ToDo",
      create_and_assing: {
        title: "ToDo list",
        description:
          "Crie e atribua atividades para serem realizadas pelos membros da equipe.",
      },
      all_your_tasks: {
        title: "Sua ToDo list",
        description:
          "Tenha uma lista com todas as suas atividades que precisam ser realizadas. Nunca se esqueça do que precisa ser feito.",
      },
      process_tasks_status: {
        title: "Filtrar ToDo list",
        description: "Em cada processo, filtre a ToDo list por status.",
      },
    },
    financial: {
      title: "Financeiro",
      subtitle: "Controle financeiro dos processos",
      features: {
        title: "Recursos",
        list: `
					<ul class="col-md-5">
						<li>Contas a pagar;</li>
						<li>Contas a receber;</li>
						<li>Centros de Custo;</li>
						<li>Receitas de processos;</li>
					</ul>
					<ul class="col-md-5">
						<li>Despesas de processos;</li>
						<li>Filtros de movimentações;</li>
						<li>Gráficos financeiros;</li>
						<li>Extrato de movimentações;</li>
					</ul>
				`,
      },
    },
  },
};
